"use strict";

import $ from "jquery";
import RangeSlider from "./RangeSlider";
import SearchFilters from "./SearchFilters";
import SelectFilters from "./SelectFilters";
import sfm from "./SearchFilterManager";

class FilterForm
{
    constructor(container = "[data-search-role='results']",
                indicator = "[data-search-role='indicator']",
                reset     = "[data-search-role='reset']") {
        // This
        this.setFilters = this.setFilters.bind(this);

        // Timeout ID
        this.tid = null;

        // Results, indicator and indicator target.
        this.container = $(container);
        this.indicator = $(indicator);
        this.reset = $(reset);
        this.panel = this.container.find("div.indicator-target");

        if (window.self !== window.top) {
            this.embedded = true;
            $("body").addClass("embedded");
        }

        // Base and previous url.
        this.url = {
            base: [window.location.protocol, "//", window.location.host, window.location.pathname].join(""),
            prev: window.location.href
        };

        // Select filters
        new SelectFilters("[data-search-role='select-filter']",
                          "[data-search-role='delegate']", {
            onChange: this.setFilters
        });

        // Search filters
        new SearchFilters("[data-search-role='filter']", {
            onChange: this.setFilters
        });

        // Range slider
        new RangeSlider("[data-range-slider]",
                        "[data-range-role='min']",
                        "[data-range-role='max']", {
            onChange: this.setFilters
        });

        // Reset the form
        $("[data-search-reset='true']").on("click", (event) => {
            event.preventDefault();
            this.resetForm();
        });
    }

    setFilters(key = null, value = null, remove = null) {
        sfm.setFilter(key, value, remove);

        clearTimeout(this.tid);
        this.tid = setTimeout(() => {
            window.history.pushState({}, "", this.url.base + "?" + $.param(sfm.urlState));
            this.getResults();
        }, 400);
    }

    getResults() {
        if (this.indicator) {
            this.indicator.addClass("active");
        }

        if (this.panel) {
            this.panel.addClass("searching");
        }

        window.axios.get(window.location.href + "&xhr=true")
            .then((response) => {
                switch (response.status) {
                    case 200:
                        this.update(response.data);
                        break;
                }
            })
            .catch((error) => {
                // In the event of an error we don't want to do anything. We should
                // remove the param from the request URL that caused the error, and
                // redirect the user back to the previous page.
                window.location = this.url.prev;
            });
    }

    update(html = false) {
        if (! html) {
            return;
        }

        if (this.indicator) {
            this.indicator.removeClass("active");
        }

        if (this.container) {
            this.container.empty().html(html);
        }

        if (this.panel) {
            // Find the results panel and hide it ...
            this.panel = this.container.find("div.indicator-target")
                                       .addClass("searching");
        }

        // Update result count.
        if ($(".result-count")) {
            $(".result-count").text($(".total-results").text());
        }

        // Show the results panel after a quick timeout.
        clearTimeout(this.tid);
        this.tid = setTimeout(() => {
            if (this.panel) {
                // Scroll to top.
                this.scrollTo($("#search-results-header"), 150);
                this.panel.removeClass("searching");
            }
        }, 400);
    }

    // Helpers

    scrollTo(el, offset) {
        if (this.embedded) {
            window.top.postMessage({
                method: "scrollFrameTo",
                offset: (el.offset().top - offset),
                type: "vs_widget"
            }, location.href);
        } else {
            $("html, body").animate({
                "scrollTop": (el.offset().top - offset)
            }, 240);
        }
    }

    // Resets

    resetForm() {
        // Tour Length
        this.resetCheckboxElement(
            $("input[name='duration']"),
            "duration",
            false);

        // Price Range
        this.resetCheckboxElement(
            $("input[name='price_range']"),
            "price_range",
            false);

        // Inc. Accommodation
        this.resetCheckboxElement(
            $("input[name='accommodation']"),
            "accommodation",
            false);

        // Inc. Price on request
        this.resetCheckboxElement(
            $("input[name='price_on_request']"),
            "price_on_request",
            false);

        // Offers
        this.resetCheckboxElement(
            $("input[name='offers']"),
            "offers",
            false);

        // Key Facilities
        this.resetCheckboxElement(
            $("input[name='facilities']"),
            "facilities",
            false);

        // Travel Type
        this.resetCheckboxElement(
            $("input[name='vehicles']"),
            "vehicles",
            false);

        // Party Size
        this.resetSelectElement($(".select-groups"), "groups");

        // Languages
        this.resetCheckboxElement(
            $("input[name='languages']"),
            "languages",
            false);

        // COVID flags
        this.resetCheckboxElement(
            $("input[name='is_open']"),
            "is_open",
            false);

        this.resetCheckboxElement(
            $("input[name='is_safe_travel']"),
            "is_safe_travel",
            false);

        this.resetCheckboxElement(
            $("input[name='is_gsab_certified']"),
            "is_gsab_certified",
            false);

        this.resetCheckboxElement(
            $("input[name='green_award']"),
            "green_award",
            false);
    }

    resetCheckboxElement(element, filterName, state) {
        if (typeof element === 'undefined') {
            return;
        }

        element.prop("checked", state).trigger("change");
        this.resetState(filterName);
    }

    resetSelectElement(element, filterName) {
        element = element[0];
        if (typeof element === 'undefined') {
            return;
        }

        element.selectedIndex = 0;
        this.resetState(filterName);
    }

    resetState(filterName) {
        this.setFilters(filterName, null, true);
    }
}

export default FilterForm;
